import { c as _c } from "react/compiler-runtime";
import { DirectionRightIcon, PasswordIcon, ShowPasswordIcon, CheckBoxIcon, UncheckBoxIcon, RegisterPasswordCheckIcon, RegisterPasswordCloseIcon } from "@/app/components/UI/Icons";
import IInput from "@/app/components/Common/Input";
import registerContent from "@/app/components/auth/registerContent";
import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import Button from "@/app/components/UI/Button";
import { PasswordRegisterFormInterface } from "@/app/components/auth/Forms/PasswordRegisterForm/passwordRegisterFormInterface";
import checkPasswordFormat from "@/app/utils/checkPasswordFormat";
import utf8ToBase64 from "@/app/utils/utf8ToBase64";
import toast from "react-hot-toast";
import { persianPattern } from "@/app/utils/Constants";
import cn from "@/app/utils/cn";
import Link from "next/link";
import { useTranslations } from "next-intl";
import { localeDirClient } from "@/app/utils/locale";
export default function PasswordRegisterForm(props) {
  const $ = _c(134);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordType, setPasswordType] = useState("password");
  const [confirmPasswordType, setConfirmPasswordType] = useState("password");
  const [checkedTerms, setCheckedTerms] = useState(false);
  const passwordRequestRef = useRef(false);
  const passwordError = confirmPassword.length > 0 && password !== confirmPassword;
  const t = useTranslations();
  let t0;
  if ($[0] !== t) {
    t0 = function passwordChange(e) {
      const value = e.target.value;
      if (persianPattern.test(value)) {
        toast.error(t("auth.ENTER_ENGLISH_LETTERS"));
        return;
      }
      setPassword(value);
    };
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const passwordChange = t0;
  let t1;
  if ($[2] !== t) {
    t1 = e_0 => {
      const value_0 = e_0.target.value;
      if (persianPattern.test(value_0)) {
        toast.error(t("auth.ENTER_ENGLISH_LETTERS"));
        return;
      }
      setConfirmPassword(value_0);
    };
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const confirmPasswordChange = t1;
  let t2;
  if ($[4] !== confirmPassword || $[5] !== password || $[6] !== props) {
    t2 = function sendPasswordFunc(e_1) {
      e_1.preventDefault();
      if (props.isPending || passwordRequestRef.current) {
        return;
      }
      passwordRequestRef.current = true;
      props.onSubmit({
        password: utf8ToBase64(password),
        re_password: utf8ToBase64(confirmPassword),
        mobile: props.mobile,
        tracking_id: props.trackingId
      });
    };
    $[4] = confirmPassword;
    $[5] = password;
    $[6] = props;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const sendPasswordFunc = t2;
  let t3;
  let t4;
  if ($[8] !== props.isError) {
    t3 = () => {
      if (props.isError) {
        passwordRequestRef.current = false;
      }
    };
    t4 = [props.isError];
    $[8] = props.isError;
    $[9] = t3;
    $[10] = t4;
  } else {
    t3 = $[9];
    t4 = $[10];
  }
  useEffect(t3, t4);
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className={cn(localeDirClient() === "ltr" ? "rotate-180" : "")}><DirectionRightIcon className="w-6 h-6" /></div>;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== props.backFunc) {
    t6 = <div className="md:hidden"><div className="mt-20 cursor-pointer" onClick={props.backFunc}>{t5}</div></div>;
    $[12] = props.backFunc;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("auth.PASSWORD");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = <h1 className="text-base md:text-2xl font-bold">{t7}</h1>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t("auth.REGISTER_PASSWORD_TEXT");
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t9) {
    t10 = <p className="text-charcoal-600 text-sm mt-4">{t9}</p>;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t8) {
    t11 = <div className="mt-6 mb-8">{t8}{t10}</div>;
    $[22] = t10;
    $[23] = t8;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t) {
    t12 = t(registerContent.password);
    $[25] = t;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== password || $[28] !== passwordChange || $[29] !== passwordType || $[30] !== t12) {
    t13 = <IInput inputId="password" label={t12} type={passwordType} value={password} onChange={passwordChange} style="secondaryOutline" autoFocus={true} />;
    $[27] = password;
    $[28] = passwordChange;
    $[29] = passwordType;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== passwordType) {
    t14 = <div className="absolute top-10 end-2 cursor-pointer" onClick={() => setPasswordType(passwordType == "password" ? "text" : "password")}>{passwordType == "password" ? <PasswordIcon className="w-6 h-6" /> : <ShowPasswordIcon className="w-6 h-6" />}</div>;
    $[32] = passwordType;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t13 || $[35] !== t14) {
    t15 = <div className="my-10 relative">{t13}{t14}</div>;
    $[34] = t13;
    $[35] = t14;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== t) {
    t16 = t(registerContent.confirmPassword);
    $[37] = t;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  const t17 = passwordError ? "secondaryOutlineError" : "secondaryOutline";
  let t18;
  if ($[39] !== confirmPassword || $[40] !== confirmPasswordChange || $[41] !== confirmPasswordType || $[42] !== passwordError || $[43] !== t16 || $[44] !== t17) {
    t18 = <IInput inputId="confirmPassword" label={t16} type={confirmPasswordType} value={confirmPassword} onChange={confirmPasswordChange} hasError={passwordError} style={t17} />;
    $[39] = confirmPassword;
    $[40] = confirmPasswordChange;
    $[41] = confirmPasswordType;
    $[42] = passwordError;
    $[43] = t16;
    $[44] = t17;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== confirmPasswordType) {
    t19 = <div className="absolute top-10 end-2 cursor-pointer" onClick={() => setConfirmPasswordType(confirmPasswordType == "password" ? "text" : "password")}>{confirmPasswordType == "password" ? <PasswordIcon className="w-6 h-6" /> : <ShowPasswordIcon className="w-6 h-6" />}</div>;
    $[46] = confirmPasswordType;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] !== passwordError || $[49] !== t) {
    t20 = passwordError && <p className="text-xs text-rojo-400 mt-1">{t("auth.WRONG_PASSWORD_TEXT")}</p>;
    $[48] = passwordError;
    $[49] = t;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  let t21;
  if ($[51] !== t18 || $[52] !== t19 || $[53] !== t20) {
    t21 = <div className="my-10 relative">{t18}{t19}{t20}</div>;
    $[51] = t18;
    $[52] = t19;
    $[53] = t20;
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  let t22;
  if ($[55] !== password) {
    t22 = checkPasswordFormat(password).hasCapitalAndSmall ? <RegisterPasswordCheckIcon className="w-6 h-6" /> : <RegisterPasswordCloseIcon className="w-6 h-6" />;
    $[55] = password;
    $[56] = t22;
  } else {
    t22 = $[56];
  }
  const t23 = "ms-2 text-xs md:text-sm " + `${checkPasswordFormat(password).hasCapitalAndSmall ? "text-charcoal-900" : "text-charcoal-600"}`;
  let t24;
  if ($[57] !== t) {
    t24 = t(registerContent.passwordCondition1);
    $[57] = t;
    $[58] = t24;
  } else {
    t24 = $[58];
  }
  let t25;
  if ($[59] !== t23 || $[60] !== t24) {
    t25 = <p className={t23}>{t24}</p>;
    $[59] = t23;
    $[60] = t24;
    $[61] = t25;
  } else {
    t25 = $[61];
  }
  let t26;
  if ($[62] !== t22 || $[63] !== t25) {
    t26 = <div className="flex mb-2">{t22}{t25}</div>;
    $[62] = t22;
    $[63] = t25;
    $[64] = t26;
  } else {
    t26 = $[64];
  }
  let t27;
  if ($[65] !== password) {
    t27 = checkPasswordFormat(password).hasNumber ? <RegisterPasswordCheckIcon className="w-6 h-6" /> : <RegisterPasswordCloseIcon className="w-6 h-6" />;
    $[65] = password;
    $[66] = t27;
  } else {
    t27 = $[66];
  }
  const t28 = "ms-2 text-xs md:text-sm " + `${checkPasswordFormat(password).hasNumber ? "text-charcoal-900" : "text-charcoal-600"}`;
  let t29;
  if ($[67] !== t) {
    t29 = t(registerContent.passwordCondition3);
    $[67] = t;
    $[68] = t29;
  } else {
    t29 = $[68];
  }
  let t30;
  if ($[69] !== t28 || $[70] !== t29) {
    t30 = <p className={t28}>{t29}</p>;
    $[69] = t28;
    $[70] = t29;
    $[71] = t30;
  } else {
    t30 = $[71];
  }
  let t31;
  if ($[72] !== t27 || $[73] !== t30) {
    t31 = <div className="flex mb-2">{t27}{t30}</div>;
    $[72] = t27;
    $[73] = t30;
    $[74] = t31;
  } else {
    t31 = $[74];
  }
  let t32;
  if ($[75] !== password) {
    t32 = checkPasswordFormat(password).hasMinimumCharacterRequired ? <RegisterPasswordCheckIcon className="w-6 h-6" /> : <RegisterPasswordCloseIcon className="w-6 h-6" />;
    $[75] = password;
    $[76] = t32;
  } else {
    t32 = $[76];
  }
  const t33 = "ms-2 text-xs md:text-sm " + `${checkPasswordFormat(password).hasMinimumCharacterRequired ? "text-charcoal-900" : "text-charcoal-600"}`;
  let t34;
  if ($[77] !== t) {
    t34 = t(registerContent.passwordCondition4);
    $[77] = t;
    $[78] = t34;
  } else {
    t34 = $[78];
  }
  let t35;
  if ($[79] !== t33 || $[80] !== t34) {
    t35 = <p className={t33}>{t34}</p>;
    $[79] = t33;
    $[80] = t34;
    $[81] = t35;
  } else {
    t35 = $[81];
  }
  let t36;
  if ($[82] !== t32 || $[83] !== t35) {
    t36 = <div className="flex mb-2">{t32}{t35}</div>;
    $[82] = t32;
    $[83] = t35;
    $[84] = t36;
  } else {
    t36 = $[84];
  }
  let t37;
  if ($[85] !== t26 || $[86] !== t31 || $[87] !== t36) {
    t37 = <div>{t26}{t31}{t36}</div>;
    $[85] = t26;
    $[86] = t31;
    $[87] = t36;
    $[88] = t37;
  } else {
    t37 = $[88];
  }
  let t38;
  if ($[89] !== checkedTerms) {
    t38 = <button type="button" onClick={e_2 => {
      e_2.preventDefault();
      setCheckedTerms(!checkedTerms);
    }}>{checkedTerms ? <CheckBoxIcon className="w-6 h-6" /> : <UncheckBoxIcon className="w-6 h-6" />}</button>;
    $[89] = checkedTerms;
    $[90] = t38;
  } else {
    t38 = $[90];
  }
  let t39;
  if ($[91] !== t) {
    t39 = t("auth.PRIVACY_POLICY");
    $[91] = t;
    $[92] = t39;
  } else {
    t39 = $[92];
  }
  let t40;
  if ($[93] !== t39) {
    t40 = <p className="text-sm font-bold text-charcoal-900"><Link href="/documents#terms" className="" target="_blank">{t39}</Link></p>;
    $[93] = t39;
    $[94] = t40;
  } else {
    t40 = $[94];
  }
  let t41;
  if ($[95] !== t) {
    t41 = t("auth.ACCEPT_POLICY");
    $[95] = t;
    $[96] = t41;
  } else {
    t41 = $[96];
  }
  let t42;
  if ($[97] !== t41) {
    t42 = <p className="text-charcoal-900 text-sm ps-1">{t41}</p>;
    $[97] = t41;
    $[98] = t42;
  } else {
    t42 = $[98];
  }
  let t43;
  if ($[99] !== t40 || $[100] !== t42) {
    t43 = <div className="flex items-center">{t40}{t42}</div>;
    $[99] = t40;
    $[100] = t42;
    $[101] = t43;
  } else {
    t43 = $[101];
  }
  let t44;
  if ($[102] !== t38 || $[103] !== t43) {
    t44 = <div className="flex items-center gap-x-2 mt-3">{t38}{t43}</div>;
    $[102] = t38;
    $[103] = t43;
    $[104] = t44;
  } else {
    t44 = $[104];
  }
  let t45;
  if ($[105] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = cn("mt-4 w-full");
    $[105] = t45;
  } else {
    t45 = $[105];
  }
  let t46;
  if ($[106] !== checkedTerms || $[107] !== confirmPassword || $[108] !== password || $[109] !== props.isPending || $[110] !== props.isSuccess) {
    t46 = !password || !confirmPassword || password !== confirmPassword || !checkedTerms || Object.values(checkPasswordFormat(password)).includes(false) || props.isPending || props.isSuccess;
    $[106] = checkedTerms;
    $[107] = confirmPassword;
    $[108] = password;
    $[109] = props.isPending;
    $[110] = props.isSuccess;
    $[111] = t46;
  } else {
    t46 = $[111];
  }
  let t47;
  if ($[112] !== sendPasswordFunc) {
    t47 = e_3 => sendPasswordFunc(e_3);
    $[112] = sendPasswordFunc;
    $[113] = t47;
  } else {
    t47 = $[113];
  }
  let t48;
  if ($[114] !== t) {
    t48 = t(registerContent.step4Button);
    $[114] = t;
    $[115] = t48;
  } else {
    t48 = $[115];
  }
  let t49;
  if ($[116] !== t48) {
    t49 = <span className="text-center">{t48} </span>;
    $[116] = t48;
    $[117] = t49;
  } else {
    t49 = $[117];
  }
  let t50;
  if ($[118] !== t46 || $[119] !== t47 || $[120] !== t49) {
    t50 = <div className={t45}><Button fullWidth={true} disabled={t46} onClick={t47}>{t49}</Button></div>;
    $[118] = t46;
    $[119] = t47;
    $[120] = t49;
    $[121] = t50;
  } else {
    t50 = $[121];
  }
  let t51;
  if ($[122] !== t15 || $[123] !== t21 || $[124] !== t37 || $[125] !== t44 || $[126] !== t50) {
    t51 = <form>{t15}{t21}{t37}{t44}{t50}</form>;
    $[122] = t15;
    $[123] = t21;
    $[124] = t37;
    $[125] = t44;
    $[126] = t50;
    $[127] = t51;
  } else {
    t51 = $[127];
  }
  let t52;
  if ($[128] !== t11 || $[129] !== t51) {
    t52 = <div className="relative">{t11}{t51}</div>;
    $[128] = t11;
    $[129] = t51;
    $[130] = t52;
  } else {
    t52 = $[130];
  }
  let t53;
  if ($[131] !== t52 || $[132] !== t6) {
    t53 = <>{t6}{t52}</>;
    $[131] = t52;
    $[132] = t6;
    $[133] = t53;
  } else {
    t53 = $[133];
  }
  return t53;
}